import React from 'react';
import ReactDOM from 'react-dom';
import { SIcon } from '@avalara/skylab-sdk/react';
const Portal = ({ children }) => {
    const [container, setContainer] = React.useState(() => document.createElement('div'));
    React.useEffect(() => {
        const rootElement = document.getElementsByTagName('aui-footer');
        if (rootElement[0]) {
            const newContainer = document.createElement('div');
            rootElement[0].insertAdjacentElement('beforebegin', newContainer);
            setContainer(newContainer);
        }
        return () => {
            var _a;
            (_a = rootElement[0]) === null || _a === void 0 ? void 0 : _a.removeChild(container);
        };
    }, []);
    return ReactDOM.createPortal(children, container);
};
const NeedAssistance = () => {
    const [marginTop, setMarginTop] = React.useState(0);
    const needAssistanceRef = React.useRef(null);
    const footerElement = document.getElementsByTagName('aui-footer')[0];
    const mainElement = document.getElementsByTagName('main')[0];
    const isThankYouPage = () => window.location.href.includes('thank-you');
    const renderFooterContent = () => {
        if (isThankYouPage()) {
            return (React.createElement("a", { href: "https://community.avalara.com/support/services/auth/sso/AvalaraIdentity?startURL=/s/onlinebuy", "data-ref": "avalara-for-shopify.need-assistance.chat-anchor" }, "Chat with a support agent"));
        }
        return (React.createElement("a", { href: "tel:+8002978855", "data-ref": "avalara-for-shopify.need-assistance.phone-anchor" },
            React.createElement(SIcon, { name: "phone", className: "pad-right-xs" }),
            "Call 800-297-8855"));
    };
    const handleResize = () => {
        const needAssistanceElement = needAssistanceRef.current;
        if (needAssistanceElement && footerElement && mainElement) {
            const mainElementRect = mainElement.getBoundingClientRect();
            const footerRect = footerElement.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const bottomValue = viewportHeight - 24 - footerRect.height;
            const distanceToFooter = bottomValue - mainElementRect.bottom;
            setMarginTop(distanceToFooter);
        }
    };
    React.useLayoutEffect(() => {
        const observer = new MutationObserver(() => {
            setMarginTop(value => value);
        });
        observer.observe(document.body, { childList: true, subtree: true });
        window.addEventListener('resize', handleResize);
        setTimeout(() => {
            handleResize();
        }, 100);
        return () => {
            window.removeEventListener('resize', handleResize);
            observer.disconnect();
        };
    }, [needAssistanceRef, footerElement, mainElement]);
    return (React.createElement(Portal, null,
        React.createElement("div", { "data-ref": "avalara-for-shopify.need-assistance", ref: needAssistanceRef, style: {
                marginTop: `${marginTop > 0 ? marginTop : 0}px`,
            } },
            React.createElement("div", { className: "flex justify-content-center" },
                React.createElement("p", { className: "font-semibold", "data-ref": "avalara-for-shopify.need-assistance.text" }, "Need assistance?"),
                React.createElement("p", { className: "pad-left-sm" }, renderFooterContent())))));
};
export default NeedAssistance;
